import { render, staticRenderFns } from "./compatibility-page.vue?vue&type=template&id=6dd40490"
import script from "./compatibility-page.vue?vue&type=script&lang=js"
export * from "./compatibility-page.vue?vue&type=script&lang=js"
import style0 from "./compatibility-page.vue?vue&type=style&index=0&id=6dd40490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./compatibility-page.vue?vue&type=custom&index=0&blockType=vuejs3-todo"
if (typeof block0 === 'function') block0(component)

export default component.exports